import { render, staticRenderFns } from "./OptionalValue.vue?vue&type=template&id=b589f9c2&lang=pug&"
import script from "./OptionalValue.vue?vue&type=script&lang=ts&"
export * from "./OptionalValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports